import * as React from 'react';

export default (
  <svg
    version="1.1"
    x="0px"
    y="0px"
    width="10px"
    height="10px"
    viewBox="7 7 10 10"
    enableBackground="new 0 0 10 10"
  >
    <g fill="none" fillRule="evenodd">
      <g id="Icons/Check" transform="translate(3, 3)" strokeWidth="1">
        <path
          d="M13.1610738,5.30663949 L6.84697987,11.4708794 L4.82818792,9.5 C4.40939597,9.09114735 3.73288591,9.09114735 3.31409396,9.5 C2.89530201,9.90885265 2.89530201,10.5693069 3.31409396,10.9781596 L6.09530201,13.6933605 C6.51409396,14.1022132 7.19060403,14.1022132 7.60939597,13.6933605 L14.685906,6.78479907 C15.104698,6.37594642 15.104698,5.71549214 14.685906,5.30663949 C14.2671141,4.89778684 13.5798658,4.89778684 13.1610738,5.30663949 Z"
          id="Icon"
          fill="#FFFFFF"
          fillRule="nonzero"
        ></path>
      </g>
    </g>
  </svg>
);
